import { render, staticRenderFns } from "./asin-target-analysis.vue?vue&type=template&id=20837906&scoped=true&"
import script from "./asin-target-analysis.vue?vue&type=script&lang=js&"
export * from "./asin-target-analysis.vue?vue&type=script&lang=js&"
import style0 from "./asin-target-analysis.vue?vue&type=style&index=0&id=20837906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20837906",
  null
  
)

export default component.exports